import { TripHomelandAllowanceDurationSource } from 'app/constants/configuration/tripHomelandAllowanceDurationSource'

export const getTripHomelandAllowanceDurationSourceName = (
  tripHomelandAllowanceDurationSource: TripHomelandAllowanceDurationSource,
  translate: (string) => string,
): string => {
  const text: string =
    TripHomelandAllowanceDurationSource[tripHomelandAllowanceDurationSource]
  return translate(`tripHomelandAllowanceDurationSource.${text}`)
}
